import {PixiAsset} from "../pixi-assets-manager/asset/pixi-asset";
import { Spine } from "../pixi-app.service.interface";
import {IDisposableObject} from "../../../../utils/disposable-object.interface";

export class PixiSpineResource implements IDisposableObject {
    constructor(public readonly asset: PixiAsset, public readonly spineAnimation: Spine) {}

    dispose() {
        this.spineAnimation.autoUpdate = false;
        this.spineAnimation.destroy();
        this.asset.dispose();
    }
}